<div class="wrapper">
  <div class="wrapper__left" *ngIf="data">
    <div class="wrapper__left__object">
      <div class="wrapper__left__object__img-box"
           [style.background-image] = "object.photo_id ? getObjectPhoto() : null"
           [style.background-size] = "'cover'"
           [style.background-repeat] = "'no-repeat'"
           [style.background-position] = "'center center'"
      >
      </div>
      <div class="wrapper__left__object__description">
        <span class="wrapper__left__object__description__caption">{{'г.'+object.city.name+' ('+object.developer.general_contractor.name+')'}}</span>
        <span class="wrapper__left__object__description__text">{{object.name}}</span>
      </div>
    </div>
    <div class="wrapper__left__bottom">
      <div class="wrapper__left__bottom__caption">Доля инвестиций АО "Казахстанская жилищная компания" и МИО</div>
      <div class="wrapper__left__bottom__container">
        <div class="wrapper__left__bottom__container__legend">
          <div class="wrapper__left__bottom__container__legend__elem">
            <div class="wrapper__left__bottom__container__legend__elem__name">АО "Казахстанская жилищная компания"</div>
            <div class="wrapper__left__bottom__container__legend__elem__number wrapper__left__bottom__container__legend__elem__number_blue">{{data.baiterek | numberMillionRound}}</div>
          </div>
          <div class="wrapper__left__bottom__container__legend__elem">
            <div class="wrapper__left__bottom__container__legend__elem__name">МИО</div>
            <div class="wrapper__left__bottom__container__legend__elem__number wrapper__left__bottom__container__legend__elem__number_purple">{{data.mio | numberMillionRound}}</div>
          </div>
        </div>
        <div class="wrapper__left__bottom__container__chart">
          <div class="chart">
            <svg version="1.1"
                 baseProfile="full"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="100%" height="100%">
              <rect width="100%" height="100%" fill="transparent"/>
              <g >
                <circle id="blue" cx="50%" cy="50%" [attr.r]="70*coef()" stroke="#217AD8" [attr.stroke-width]="13*coef()"  stroke-dasharray ="0" stroke-dashoffset="0" fill="none" />
              </g>
            </svg>
            <svg class="chart__sector"
                 [ngStyle]="{'transform': 'translate(50%, -50%) rotate(-90deg) rotateX(180deg)'}"
            >
              <g>
                <circle id="purp" cx="50%" cy="50%" [attr.r]="70*coef()" stroke="#9900CC" [attr.stroke-width]="13*coef()"  [attr.stroke-dasharray] ="(pieData.purple)*6.29*70*coef()+' '+(1-pieData.purple)*6.29*70*coef()" [attr.stroke-dashoffset]="0" fill="none" />
              </g>
            </svg>
            <svg class="chart__thin">
                <g>
                    <circle id="dark_blue_thin" cx="50%" cy="50%" [attr.r]="85*coef()" stroke="rgba(17,37,63,1)" [attr.stroke-width]="5*coef()"  stroke-dasharray ="0" stroke-dashoffset="0" fill="none" />
                </g>
            </svg>
              <svg class="chart__thin__blue-sector"
                   [ngStyle]="{'transform': 'translate(50%, -50%) rotateY(180deg)'}"
              >
                  <g>
                      <circle id="blue_thin" cx="50%" cy="50%" [attr.r]="85*coef()" stroke="#217AD8" [attr.stroke-width]="5*coef()"  [attr.stroke-dasharray] ="(pieData.thinBlue)*6.29*85*coef()+' '+(1-pieData.thinBlue)*6.29*85*coef()" [attr.stroke-dashoffset]="(0.25+pieData.thinBlue)*6.29*85*coef()" fill="none" />
                  </g>
              </svg>
              <svg class="chart__thin__purple-sector_dark"
                   [ngStyle]="{'transform': 'translate(50%, -50%) rotate(-90deg) rotateX(180deg)'}"
              >
                  <g>
                      <circle id="dark_purple_thin" cx="50%" cy="50%" [attr.r]="85*coef()" stroke="rgba(50,13,60,1)" [attr.stroke-width]="5*coef()"  [attr.stroke-dasharray] ="(pieData.purple)*6.29*85*coef()+' '+(1-pieData.purple)*6.29*85*coef()" [attr.stroke-dashoffset]="0" fill="none"/>
                  </g>
                <g>
                  <circle id="purple_thin" cx="50%" cy="50%" [attr.r]="85*coef()" stroke="#9900CC" [attr.stroke-width]="5*coef()"  [attr.stroke-dasharray] ="(pieData.thinPurple)*6.29*85*coef()+' '+(1-pieData.thinPurple)*6.29*85*coef()" [attr.stroke-dashoffset]="" fill="none" />
                </g>
              </svg>

            <svg class="purple__dot"
                 *ngIf="data.pie.secondPercent!=0"
                 [ngStyle]="{'transform': 'translate(50%, -50%) rotate('+(-90-pieData.thinPurple*360)+'deg)'}"
            >
              <g>
                <circle id="purple_dot" [attr.cx]="'calc('+85*coef()+'px + 50%)'" [attr.cy]="'50%'" [attr.r]="4*coef()" stroke="#0d1019" [attr.stroke-width]="2*coef()" fill="#9900CC" />
              </g>
            </svg>
            <svg class="blue__dot"
                 *ngIf="data.pie.firstPercent!=0"
                 [ngStyle]="{'transform': 'translate(50%, -50%) rotateY(180deg) rotate('+(-90-pieData.thinBlue*360)+'deg)'}"
            >
              <circle id="blue_dot" [attr.cx]="'calc('+85*coef()+'px + 50%)'" [attr.cy]="'50%'" [attr.r]="4*coef()" stroke="#0d1019" [attr.stroke-width]="2*coef()" fill="#217AD8" />
            </svg>
              <svg class="purple__text"
                   *ngIf="data.pie.secondPercent!=0"
                   [ngStyle]=""
              >
                  <text class="purple__text__text"
                        [attr.x]="'50%'"
                        [attr.y]="'50%'"
                        text-anchor="middle"
                        [ngStyle]="{'transform': 'translate('+pieData.pTextX*106*coef()+'px,'+pieData.pTextY*103*coef()+'px)'}"
                  >{{(data.pie.secondPercent | numberMillionRound) +'% '}}</text>
              </svg>
            <svg class="purple__text"
                 *ngIf="data.pie.firstPercent!=0"
                 [ngStyle]=""
            >
              <text class="blue__text__text"
                    [attr.x]="'50%'"
                    [attr.y]="'50%'"
                    text-anchor="middle"
                    [ngStyle]="{'transform': 'translate('+pieData.bTextX*106*coef()+'px,'+pieData.bTextY*103*coef()+'px)'}"
              >{{' '+(data.pie.firstPercent | numberMillionRound)+'% '}}</text>
            </svg>

            <div class="chart__text">
              <div class="chart__text__small">План, млн.тг</div>
              <div class="chart__text__big" style="margin-bottom: 1.5%">{{data.pie.plan | numberMillionRound}}</div>
              <div class="chart__text__small">Освоено, млн.тг</div>
              <div class="chart__text__big">{{data.pie.purchased | numberMillionRound}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper__right" *ngIf="data">
    <app-column-money-chart  class="wrapper__right__chart" [chartData]="data.bar"></app-column-money-chart>
  </div>
</div>
